<template>
    <div class="season-box__table__row">

        <div class="season-box__table__main">
            <div class="season-box__badge"><span>{{title}}</span></div>
        </div>
        <div class="season-box__table__currency">
            <div :class="['select-wrapper', 'select-wrapper--xs', { 'is-active' : select }]" @click="select = !select">
                <div class="select-trigger"><span class="select-trigger__name">{{currency}}</span><span class="select-trigger__icon">
                    <svg width="1em" height="1em" class="icon icon-chevron ">
                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                    </svg></span></div>
                <div class="select-body">
                    <div class="select-inner">
                    <div :class="['select-option', {'is-selected' : currency === 'USD'}]" @click="$emit('changeCurrency', { name: nameCur, value: 'USD', index: index })"><span class="select-option__name">USD</span></div>
                    <div :class="['select-option', {'is-selected' : currency === 'TZS'}]" @click="$emit('changeCurrency', { name: nameCur, value: 'TZS', index: index })"><span class="select-option__name">TZS</span></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="season-box__table__price">
            <input type="number" :placeholder="value1" v-model="input1" @focus="$event.target.parentElement.classList.remove('is-error')" class="form-control form-control-price"/>
        </div>
        <div class="season-box__table__price">
            <input type="number" :placeholder="value2" v-model="input2" @focus="$event.target.parentElement.classList.remove('is-error')" class="form-control form-control-price"/>
        </div>
        <div class="season-box__table__price">
            <input type="number" :placeholder="value3" v-model="input3" @focus="$event.target.parentElement.classList.remove('is-error')" class="form-control form-control-price"/>
        </div>
        <div class="season-box__table__price">
            <input type="number" :placeholder="value4" v-model="input4" @focus="$event.target.parentElement.classList.remove('is-error')" class="form-control form-control-price"/>
        </div>
        <div class="season-box__table__price">
            <input type="number" :placeholder="value5" v-model="input5" @focus="$event.target.parentElement.classList.remove('is-error')" class="form-control form-control-price"/>
        </div>
        <div class="season-box__table__price">
            <input type="number" :placeholder="value6" v-model="input6" @focus="$event.target.parentElement.classList.remove('is-error')" class="form-control form-control-price"/>
        </div>
        <div class="season-box__table__price">
            <input type="number" :placeholder="value7" v-model="input7" @focus="$event.target.parentElement.classList.remove('is-error')" class="form-control form-control-price"/>
        </div>
        <div class="season-box__table__price">
            <input type="number" :placeholder="value8" v-model="input8" @focus="$event.target.parentElement.classList.remove('is-error')" class="form-control form-control-price"/>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['title', 
            'currency', 
            'placeholder', 
            'value1', 
            'value2', 
            'value3', 
            'value4', 
            'value5', 
            'value6', 
            'value7', 
            'value8', 
            'name1', 
            'name2', 
            'name3', 
            'name4', 
            'name5', 
            'name6', 
            'name7', 
            'name8',
            'nameCur', 
            'index'],
        data(){
            return {
                select: false,
                input1: '',
                input2: '',
                input3: '',
                input4: '',
                input5: '',
                input6: '',
                input7: '',
                input8: '',
            }
        },
        mounted(){
            this.input1 = this.value1
            this.input2 = this.value2
            this.input3 = this.value3
            this.input4 = this.value4
            this.input5 = this.value5
            this.input6 = this.value6
            this.input7 = this.value7
            this.input8 = this.value8
            window.addEventListener('click', event => {
                if(!event.target.closest('.select-wrapper')){
                    this.select = false
                } else {
        
                }
                if(event.target.closest('.season-box__table__row')){
                    this.$emit('closeSelects')
                }
            })
            const onClickOutside = e => {
                this.select = this.$el.contains(e.target) && this.select
            };
            document.addEventListener('click', onClickOutside);
            this.$on('hook:beforeDestroy', () => document.removeEventListener('click', onClickOutside));
        },
        watch: {
            input1(){
                this.$emit('changeValue', { name: this.name1, value: this.input1, index: this.index })
            },
            input2(){
                this.$emit('changeValue', { name: this.name2, value: this.input2, index: this.index })
            },
            input3(){
                this.$emit('changeValue', { name: this.name3, value: this.input3, index: this.index })
            },
            input4(){
                this.$emit('changeValue', { name: this.name4, value: this.input4, index: this.index })
            },
            input5(){
                this.$emit('changeValue', { name: this.name5, value: this.input5, index: this.index })
            },
            input6(){
                this.$emit('changeValue', { name: this.name6, value: this.input6, index: this.index })
            },
            input7(){
                this.$emit('changeValue', { name: this.name7, value: this.input7, index: this.index })
            },
            input8(){
                this.$emit('changeValue', { name: this.name8, value: this.input8, index: this.index })
            },
            value1(){
                this.input1 = this.value1
            },
            value2(){
                this.input2 = this.value2
            },
            value3(){
                this.input3 = this.value3
            },
            value4(){
                this.input4 = this.value4
            },
            value5(){
                this.input5 = this.value5
            },
            value6(){
                this.input6 = this.value6
            },
            value7(){
                this.input7 = this.value7
            },
            value8(){
                this.input8 = this.value8
            },
        },
    }
</script>

